import { MFExecutionData } from '../../types/mf-execution.types'

export const isWhitelistedAndNoUserInvestmentStatus = (
  mfExecutionData: MFExecutionData | undefined
): boolean => {
  return (
    mfExecutionData?.isWhitelisted === true &&
    (mfExecutionData?.userInvestmentStatus === null || mfExecutionData?.userInvestmentStatus === undefined)
  )
}
